/* ================================================
   Messoanuovo — Assistenza & Resi JS
   Wizard · Validation · Upload · EmailJS
   ================================================ */
(function () {
  'use strict';

  /* ── Config ── */
  var CFG = {
    emailjsPK:        '4Bz_148FJzMHtD8Bu',
    emailjsService:   'service_vomlg0k',
    tmplStaff:        'template_pbnidug',
    tmplClient:       'template_52as6q7',
    cloudinaryCloud:  'djfp8sgdj',
    cloudinaryPreset: 'messoanuovo_uploads'
  };

  /* ── State ── */
  var S = {
    step: 1,
    requestType: null,         // 'assistenza' | 'reso'
    nome: '', azienda: '', email: '', telefono: '',
    numeroOrdine: '', tipoProdotto: '', modello: '',
    categoriaProblema: '', descrizioneAssistenza: '',
    motivoReso: '', descrizioneReso: '',

    photos: [],                // File objects
    video: null,               // File object
    gdpr: false,
    ticket: null
  };

  /* ── Boot ── */
  function boot() {
    loadEmailJS();
    bindStep1();
    bindStep2();
    bindStep3();
    bindStep4();
  }

  /* ── Load EmailJS ── */
  function loadEmailJS() {
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
    s.onload = function () {
      if (window.emailjs) emailjs.init({ publicKey: CFG.emailjsPK });
    };
    document.head.appendChild(s);
  }

  /* ── Stepper ── */
  function updateStepper(n) {
    document.querySelectorAll('.mn-ar-step-item').forEach(function (item, i) {
      var num = i + 1;
      item.classList.remove('active', 'completed');
      if (num < n) item.classList.add('completed');
      else if (num === n) item.classList.add('active');

      var circle = item.querySelector('.mn-ar-step-circle');
      if (!circle) return;
      circle.innerHTML = num < n ? '&#10003;' : String(num);
    });
  }

  function showStep(n) {
    document.querySelectorAll('.mn-ar-step-panel').forEach(function (p) {
      p.classList.remove('active');
    });
    var panel = document.getElementById('mn-ar-step-' + n);
    if (panel) panel.classList.add('active');
    S.step = n;
    updateStepper(n);
    var wizard = document.getElementById('mn-ar-wizard');
    if (wizard) {
      var top = wizard.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  /* ═══════════════════════════════════════
     STEP 1 — Tipo richiesta
  ═══════════════════════════════════════ */
  function bindStep1() {
    document.querySelectorAll('.mn-ar-sel-card').forEach(function (card) {
      card.addEventListener('click', function () {
        document.querySelectorAll('.mn-ar-sel-card').forEach(function (c) {
          c.classList.remove('selected');
        });
        card.classList.add('selected');
        S.requestType = card.dataset.type;
        var btn = document.getElementById('mn-ar-btn-next-1');
        if (btn) btn.disabled = false;
        var err = document.getElementById('mn-ar-step-1-error');
        if (err) err.style.display = 'none';
      });
    });

    on('mn-ar-btn-next-1', 'click', function () {
      if (!S.requestType) {
        showInlineError('mn-ar-step-1-error', 'Seleziona un tipo di richiesta per procedere.');
        return;
      }
      showStep(2);
    });
  }

  /* ═══════════════════════════════════════
     STEP 2 — Dati personali
  ═══════════════════════════════════════ */
  function bindStep2() {
    // Email live validation
    var emailEl = document.getElementById('mn-ar-email');
    if (emailEl) {
      emailEl.addEventListener('blur', function () {
        var v = emailEl.value.trim();
        if (v && isValidEmail(v)) {
          emailEl.classList.add('valid');
          emailEl.classList.remove('error');
        } else if (v) {
          emailEl.classList.remove('valid');
          emailEl.classList.add('error');
        }
      });
      emailEl.addEventListener('input', function () {
        emailEl.classList.remove('valid', 'error');
      });
    }

    on('mn-ar-btn-back-2', 'click', function () { showStep(1); });

    on('mn-ar-btn-next-2', 'click', function () {
      if (!validateStep2()) return;
      S.nome     = val('mn-ar-nome');
      S.azienda  = val('mn-ar-azienda');
      S.email    = val('mn-ar-email');
      S.telefono = val('mn-ar-telefono');
      showStep(3);
      renderStep3();
    });
  }

  function validateStep2() {
    var ok = true;
    var fields = [
      { id: 'mn-ar-nome',     msg: 'Inserisci nome e cognome' },
      { id: 'mn-ar-email',    msg: 'Inserisci un indirizzo email valido', validate: isValidEmail },
      { id: 'mn-ar-telefono', msg: 'Inserisci il numero di telefono' }
    ];
    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      if (!el) return;
      var v = el.value.trim();
      var valid = f.validate ? (!!v && f.validate(v)) : !!v;
      if (!valid) { markFieldError(el, f.msg); ok = false; }
      else clearFieldError(el);
    });
    return ok;
  }

  /* ═══════════════════════════════════════
     STEP 3 — Ordine + Dettagli + Allegati
  ═══════════════════════════════════════ */
  function renderStep3() {
    var badge  = document.getElementById('mn-ar-step3-badge');
    var title  = document.getElementById('mn-ar-step3-title');
    var panelA = document.getElementById('mn-ar-panel-3a');
    var panelB = document.getElementById('mn-ar-panel-3b');

    if (S.requestType === 'assistenza') {
      if (badge)  { badge.className = 'mn-ar-req-badge assistenza'; badge.innerHTML = '&#128296; Richiesta Assistenza'; }
      if (title)  title.textContent = 'Descrivi il problema';
      if (panelA) panelA.style.display = '';
      if (panelB) panelB.style.display = 'none';
    } else {
      if (badge)  { badge.className = 'mn-ar-req-badge reso'; badge.innerHTML = '&#128230; Reso o Sostituzione'; }
      if (title)  title.textContent = 'Dettagli del reso';
      if (panelA) panelA.style.display = 'none';
      if (panelB) panelB.style.display = '';
    }
  }

  function bindStep3() {
    // Textarea counters
    bindCounter('mn-ar-desc-assistenza', 'mn-ar-counter-assistenza', 1000);
    bindCounter('mn-ar-desc-reso',       'mn-ar-counter-reso',       800);

    // Dropzone
    var zone = document.getElementById('mn-ar-dropzone-main');
    if (zone) bindDropzone(zone);

    // Navigation
    on('mn-ar-btn-back-3', 'click', function () { showStep(2); });

    on('mn-ar-btn-next-3', 'click', function () {
      // Salva dati ordine
      var ordEl = document.getElementById('mn-ar-ordine');
      if (ordEl) clearFieldError(ordEl);
      S.numeroOrdine = ordEl ? ordEl.value.trim() : '';
      S.tipoProdotto = val('mn-ar-tipo-prodotto');
      S.modello      = val('mn-ar-modello');

      // Valida e salva dettagli
      if (!validateStep3()) return;

      if (S.requestType === 'assistenza') {
        S.categoriaProblema     = '';
        S.descrizioneAssistenza = val('mn-ar-desc-assistenza');
      } else {
        S.motivoReso    = val('mn-ar-motivo-reso');
        S.descrizioneReso = val('mn-ar-desc-reso');
      }

      buildSummary();
      showStep(4);
    });
  }

  function validateStep3() {
    var ok = true;

    if (S.requestType === 'assistenza') {
      var descEl = document.getElementById('mn-ar-desc-assistenza');
      if (!descEl || !descEl.value.trim()) { if (descEl) markFieldError(descEl, 'La descrizione è obbligatoria'); ok = false; }
      else clearFieldError(descEl);
    } else {
      var motEl = document.getElementById('mn-ar-motivo-reso');
      if (!motEl || !motEl.value) { if (motEl) markFieldError(motEl, 'Seleziona il motivo del reso'); ok = false; }
      else clearFieldError(motEl);
    }

    return ok;
  }

  /* ── Dropzone ── */
  function bindDropzone(zone) {
    var previews = document.getElementById('mn-ar-previews');
    var countEl  = document.getElementById('mn-ar-file-count');
    var input    = zone.querySelector('input[type="file"]');

    zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('dragover'); });
    zone.addEventListener('dragleave', function ()  { zone.classList.remove('dragover'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('dragover');
      handleFiles(Array.prototype.slice.call(e.dataTransfer.files), previews, countEl);
    });

    if (input) {
      input.addEventListener('change', function () {
        handleFiles(Array.prototype.slice.call(input.files), previews, countEl);
        input.value = '';
      });
    }
  }

  function handleFiles(files, previews, countEl) {
    files.forEach(function (file) {
      var isVideo = file.type.indexOf('video/') === 0;
      var isImage = file.type.indexOf('image/') === 0;

      if (isVideo) {
        if (S.video) { alert('Puoi caricare massimo 1 video.'); return; }
        if (file.size > 50 * 1024 * 1024) { alert('Il video supera il limite di 50 MB.'); return; }
        S.video = file;
        addPreview(file, true, previews);
      } else if (isImage) {
        if (S.photos.length >= 5) { alert('Puoi caricare massimo 5 foto.'); return; }
        var totalSize = S.photos.reduce(function (s, f) { return s + f.size; }, 0) + file.size;
        if (totalSize > 10 * 1024 * 1024) { alert('Le foto superano il limite totale di 10 MB.'); return; }
        S.photos.push(file);
        addPreview(file, false, previews);
      }
      updateFileCount(countEl);
    });
  }

  function addPreview(file, isVideo, previewsEl) {
    if (!previewsEl) return;
    var item = document.createElement('div');
    item.className = 'mn-ar-preview-item';

    if (isVideo) {
      item.innerHTML = '<div class="mn-ar-preview-video-thumb">&#9654;</div>';
    } else {
      var url = URL.createObjectURL(file);
      var img = document.createElement('img');
      img.src = url;
      img.alt = file.name;
      item.appendChild(img);
    }

    var btn = document.createElement('button');
    btn.className = 'mn-ar-preview-remove';
    btn.type = 'button';
    btn.innerHTML = '&times;';
    btn.addEventListener('click', function () {
      if (isVideo) {
        S.video = null;
      } else {
        var idx = S.photos.indexOf(file);
        if (idx > -1) S.photos.splice(idx, 1);
      }
      item.remove();
      var countEl = document.getElementById('mn-ar-file-count');
      updateFileCount(countEl);
    });

    item.appendChild(btn);
    previewsEl.appendChild(item);
  }

  function updateFileCount(countEl) {
    if (!countEl) return;
    var parts = [];
    if (S.photos.length > 0) parts.push(S.photos.length + ' di 5 foto caricate');
    if (S.video) parts.push('1 di 1 video caricato');
    countEl.textContent = parts.join(' · ');
  }

  /* ═══════════════════════════════════════
     STEP 4 — Riepilogo & invio
  ═══════════════════════════════════════ */
  function buildSummary() {
    setText('mn-ar-sum-type', S.requestType === 'assistenza' ? 'Richiesta Assistenza' : 'Reso o Sostituzione');

    setText('mn-ar-sum-nome',     S.nome + (S.azienda ? ' \u2014 ' + S.azienda : ''));
    setText('mn-ar-sum-email',    S.email);
    setText('mn-ar-sum-telefono', '+39 ' + S.telefono);

    setText('mn-ar-sum-ordine',     S.numeroOrdine);
    setText('mn-ar-sum-tipo-prod',  S.tipoProdotto || '\u2014');
    setText('mn-ar-sum-modello',    S.modello || '\u2014');

    var detailsA = document.getElementById('mn-ar-sum-details-a');
    var detailsB = document.getElementById('mn-ar-sum-details-b');

    if (S.requestType === 'assistenza') {
      if (detailsA) detailsA.style.display = '';
      if (detailsB) detailsB.style.display = 'none';
      setText('mn-ar-sum-categoria', S.categoriaProblema);
      var desc = S.descrizioneAssistenza;
      setText('mn-ar-sum-desc', desc.length > 90 ? desc.slice(0, 90) + '\u2026 (espandi)' : desc);
    } else {
      if (detailsA) detailsA.style.display = 'none';
      if (detailsB) detailsB.style.display = '';
      setText('mn-ar-sum-motivo', S.motivoReso);
    }

    var attParts = [];
    if (S.photos.length) attParts.push(S.photos.length + ' foto');
    if (S.video)         attParts.push('1 video');
    setText('mn-ar-sum-allegati', attParts.length ? attParts.join(' · ') : 'Nessuno');
  }

  function bindStep4() {
    // GDPR toggle
    var gdprEl    = document.getElementById('mn-ar-gdpr');
    var submitBtn = document.getElementById('mn-ar-btn-submit');

    if (gdprEl) {
      gdprEl.addEventListener('click', function () {
        S.gdpr = !S.gdpr;
        gdprEl.classList.toggle('checked', S.gdpr);
        var box = gdprEl.querySelector('.mn-ar-gdpr-box');
        if (box) box.innerHTML = S.gdpr ? '&#10003;' : '';
        if (submitBtn) submitBtn.disabled = !S.gdpr;
      });
    }

    // Edit links (go to specific step)
    document.querySelectorAll('[data-goto]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var n = parseInt(el.dataset.goto, 10);
        showStep(n);
        if (n === 3) renderStep3();
      });
    });

    on('mn-ar-btn-back-4', 'click', function () {
      showStep(3);
      renderStep3();
    });

    if (submitBtn) submitBtn.addEventListener('click', handleSubmit);
  }

  /* ═══════════════════════════════════════
     SUBMIT
  ═══════════════════════════════════════ */
  function generateTicket() {
    var year = new Date().getFullYear();
    var num  = String(Math.floor(Math.random() * 99999) + 1).padStart(5, '0');
    return 'MN-' + year + '-' + num;
  }

  function uploadToCloudinary(file) {
    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', CFG.cloudinaryPreset);

      var url = 'https://api.cloudinary.com/v1_1/' + CFG.cloudinaryCloud + '/auto/upload';

      fetch(url, { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) throw new Error('Upload error ' + r.status);
          return r.json();
        })
        .then(function (data) {
          resolve(data.secure_url);
        })
        .catch(reject);
    });
  }

  async function handleSubmit() {
    var submitBtn  = document.getElementById('mn-ar-btn-submit');
    var submitArea = document.getElementById('mn-ar-submit-area');

    if (submitBtn) submitBtn.disabled = true;
    if (submitArea) {
      submitArea.innerHTML =
        '<div class="mn-ar-sending"><div class="mn-ar-spinner"></div>Invio in corso&hellip;</div>';
    }

    try {
      /* ── Upload files ── */
      var photoUrls = [];
      for (var i = 0; i < S.photos.length; i++) {
        var url = await uploadToCloudinary(S.photos[i]);
        photoUrls.push(url);
      }

      var videoUrl = null;
      if (S.video) videoUrl = await uploadToCloudinary(S.video);

      /* ── Ticket ── */
      var ticket = generateTicket();
      S.ticket   = ticket;

      /* ── Date/time ── */
      var now     = new Date();
      var dateStr = now.toLocaleString('it-IT', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });

      var isAss = S.requestType === 'assistenza';

      /* ── Staff email params ── */
      var staffParams = {
        ticket_number:        ticket,
        request_type:         isAss ? 'Assistenza Tecnica' : 'Reso o Sostituzione',
        nome:                 S.nome,
        azienda:              S.azienda || 'Non specificata',
        email:                S.email,
        telefono:             '+39 ' + S.telefono,
        numero_ordine:        S.numeroOrdine,
        tipo_prodotto:        S.tipoProdotto || 'Non specificato',
        modello:              S.modello || 'Non specificato',
        categoria_problema:   isAss ? S.categoriaProblema : '\u2014',
        descrizione_ass:      isAss ? S.descrizioneAssistenza : '\u2014',
        motivo_reso:          isAss ? '\u2014' : S.motivoReso,
        descrizione_reso:     isAss ? '\u2014' : (S.descrizioneReso || 'Non fornita'),

        foto_urls:            photoUrls.join(' | ') || 'Nessuna',
        video_url:            videoUrl || 'Nessuno',
        data_ora:             dateStr,
        url_pagina:           'messoanuovo.it/pages/assistenza-resi'
      };

      /* ── Client email params ── */
      var clientParams = {
        ticket_number: ticket,
        request_type:  isAss ? 'assistenza' : 'reso',
        nome:          S.nome,
        email:         S.email,
        telefono:      '+39 ' + S.telefono,
        numero_ordine: S.numeroOrdine,
        modello:       S.modello || 'Non specificato'
      };

      /* ── Send ── */
      await emailjs.send(CFG.emailjsService, CFG.tmplStaff,  staffParams);
      await emailjs.send(CFG.emailjsService, CFG.tmplClient, clientParams);

      /* ── Success ── */
      showSuccess(ticket);

    } catch (err) {
      console.error('[MN] Submit error:', err);
      if (submitArea) {
        submitArea.innerHTML =
          '<div style="text-align:center;padding:16px;">' +
          '<p style="color:var(--mn-red);margin-bottom:14px;">&#9888; Errore durante l\'invio. Riprova o scrivici direttamente a ' +
          '<a href="mailto:info@computersparts.it" style="color:var(--mn-red);">info@computersparts.it</a>.</p>' +
          '<button class="mn-ar-btn mn-ar-btn-primary" onclick="location.reload()" type="button">Riprova</button>' +
          '</div>';
      }
    }
  }

  /* ═══════════════════════════════════════
     SUCCESS PAGE
  ═══════════════════════════════════════ */
  function showSuccess(ticket) {
    var wizard  = document.getElementById('mn-ar-wizard');
    var stepper = document.querySelector('.mn-ar-stepper-wrap');
    var success = document.getElementById('mn-ar-success');

    if (wizard)  wizard.style.display  = 'none';
    if (stepper) stepper.style.display = 'none';
    if (success) success.classList.add('active');

    setText('mn-ar-success-ticket', ticket);
    setText('mn-ar-success-email',  S.email);

    // Copy button
    var copyBtn = document.getElementById('mn-ar-copy-ticket');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(ticket).then(function () {
            copyBtn.textContent = '\u2713 Copiato!';
            copyBtn.classList.add('copied');
            setTimeout(function () {
              copyBtn.innerHTML = '&#128203; Copia numero ticket';
              copyBtn.classList.remove('copied');
            }, 2500);
          });
        } else {
          // Fallback
          var ta = document.createElement('textarea');
          ta.value = ticket;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          copyBtn.textContent = '\u2713 Copiato!';
          copyBtn.classList.add('copied');
          setTimeout(function () {
            copyBtn.innerHTML = '&#128203; Copia numero ticket';
            copyBtn.classList.remove('copied');
          }, 2500);
        }
      });
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ═══════════════════════════════════════
     HELPERS
  ═══════════════════════════════════════ */
  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function setText(id, text) {
    var el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  function on(id, ev, fn) {
    var el = document.getElementById(id);
    if (el) el.addEventListener(ev, fn);
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function markFieldError(el, msg) {
    el.classList.add('error');
    el.classList.remove('valid');
    var field = el.closest('.mn-ar-field');
    if (!field) return;
    field.classList.add('has-error');
    var err = field.querySelector('.mn-ar-field-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'mn-ar-field-error';
      field.appendChild(err);
    }
    err.textContent = msg;
    err.style.display = 'block';
  }

  function clearFieldError(el) {
    el.classList.remove('error');
    var field = el.closest('.mn-ar-field');
    if (!field) return;
    field.classList.remove('has-error');
    var err = field.querySelector('.mn-ar-field-error');
    if (err) err.style.display = 'none';
  }

  function showInlineError(id, msg) {
    var el = document.getElementById(id);
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  function bindCounter(taId, counterId, max) {
    var ta      = document.getElementById(taId);
    var counter = document.getElementById(counterId);
    if (!ta || !counter) return;

    function update() {
      var len = ta.value.length;
      if (len > max) { ta.value = ta.value.slice(0, max); len = max; }
      counter.textContent = len + '/' + max;
      counter.className = 'mn-ar-counter';
      if (len > max * 0.85) counter.classList.add('warn');
      if (len >= max)       counter.classList.add('over');
    }

    ta.addEventListener('input', update);
    update();
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
